import React from 'react';
import { useState, useEffect } from 'react';
import Navbar from '../ExternalDashboard/components/Navbar/Navbar';
import CommonVariables from '../variables';
import Notifications from '../Notifications/Messages';

function ExternalDashboardlayout(props) {
    useEffect(function () {
        let localstorageData = CommonVariables.getlocalstorageData()
        if (localstorageData.accessToken) {
            Notifications.ShowSuccessMessage(localstorageData.email ? "Welcome " + localstorageData.email : "Welcome User");
        }
    }, []);

    return (
        <div>
            <Navbar {...props} />
            {props.RouterInfo.children}
        </div>
    );
}

export default ExternalDashboardlayout;